<template>
  <div>
    <el-dialog
      v-drag
      :visible.sync="headerAIDrawer"
      :custom-class="amplifyShow?'AIdrawer AIdraweramplify': 'AIdrawer'"
      class="AIdrawerWrapper"
      :modal="false" 
      title=""
      :modal-append-to-body="false"
      :close-on-press-escape="false"
      :lock-scroll="false" 
      :close-on-click-modal="false" 
      :append-to-body="true"
      :show-close="false"
      @closed="closed"
      >
      <template slot="title">
        <div class="titleDiv">
          <span>海智AI助手-助力您外贸出海更顺畅</span>
          <i class=" iconfont fontamplify" :class="amplifyShow?'icon-icon-suoxiao': 'icon-icon-fangda'"  @click="amplify"></i>
          <i class="iconfont icon-icon-guanbi  fontclose" @click="handleClose"></i>
        </div>
       
      </template>
      <div class="aiDrawerConterDiv">
        <!-- <i class="el-icon-close  fontclose" @click="handleClose"></i> -->
        <div :class="'AIBgText'+creditShow"  >
          <!-- <div :class="creditShow?'title':'titleTop'">
            海智AI助手-助力您外贸出海更顺畅
          </div> -->
          <el-row class="introduce" v-show="false" >
            <el-col :span="8" >
              <div class="content">
                <div class="ImgDiv"><img src="@/assets/image/common/process.png" alt=""></div>
                <div class="contentText">合作流程</div>
                <div class="processConter">
                  <div>·了解外贸接单后合作流程细节</div>
                  <div>·外贸合作后涉及的单据有哪些？</div>
                </div>
              </div>
            </el-col>
            <el-col :span="8" > 
              <div class="content">
                <div class="ImgDiv"><img src="@/assets/image/common/Email.png" alt=""></div>
                <div class="contentText">邮件营销</div>
                <div class="EmailConter">
                  <div>·圣诞节给客户发一封祝福邮件</div>
                  <div class="EmailDiv">·给欧美新客户做个公司介绍，邮件怎么写？</div>
                </div>
              </div>
            </el-col>
            <el-col :span="8" >
              <div class="content">
                <div class="ImgDiv"><img src="@/assets/image/common/interact.png" alt=""></div>
                <div class="contentText">沟通话术</div>
                <div class="interactConter">
                  <div>·欧美客户沟通需要注意哪些礼节</div>
                  <div>·外贸新人，如何与客户打开话匣子</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="templateCard"  v-show="creditShow" >
            <div v-for="(item,index) in list" :key="index" id="templateCard">
              <div class="myQuestion" v-if="item.code==0">
                <div class="myQuestionImg">
                  <div class="divImg">Me</div>
                </div>
                <div class="myQuestionText" >{{item.content}}</div>
              </div>
              <div class="answerDiv" v-if="item.code==1">
                <div class="answer">
                  <div class="answerImg">
                    <div class="divImg"><img src="@/assets/image/common/haizolAIImg.png" alt=""></div>
                  </div>
                  <div class="answerText">
                    <div :id="'content_'+index" >
                      <div>
                        {{item.content}}
                      </div>
                    </div>
                    <div>
                      <el-button type="primary" size="mini" @click="copy(item.content)" class="copy" v-if="item.btnShow" >复制</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-row>
          <div class="requestInput">
            <div>
              <el-input @blur="blur"  class="textareaInput" :disabled="loading" :autosize="{ minRows:1, maxRows: 6}" type="textarea"  placeholder="输入您的内容要求，描述的越精准内容生成的质量越高"  v-model="request" :rows="1">
              </el-input>
            </div>
            <div  :class="'appendBtnDiv'+loading">
              <el-button  class="appendBtn"  :disabled="balance==0||request==''" @click="createdValue"  :loading="loading">{{loading?'生成中…':'开始生成'}}</el-button>
            </div>
            <div class="problemTitle">
            <!-- <span>邮件内容/邮件翻译</span>
            <span class="problemTitleSpan">沟通话术</span>
            <span>合作流程</span> -->
            <span class="todayuse">当日使用：{{creditUse}}/{{creditsValue}}</span>
          </div>
          </div>
          <div :class="creditShow?'ExampleconteDiv':'ExampleconteDivTop'" >
            <el-form class="Example" >
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="邮件内容/邮件翻译" name="first">
                  <div class="ExampleDivtitle">
                    使用示例：
                  </div>
                  <div class="ExampleDiv">
                    · 我是一家做<span>机加工的中国工厂</span>，
                    我想用<span>英文</span>给我的<span>外贸客户</span>发一封<span>圣诞节祝福邮件</span>
                    <span class="use" @click="useActive('我是一家做机加工的中国工厂，我想用英文给我的外贸客户发一封圣诞节祝福邮件')">使用场景</span>
                  </div>
                  <div class="ExampleDiv">
                    · 我是一家做<span>非标零部件的中国工厂</span>，
                    我想用<span>英文</span>给我的<span>外贸客户</span>发一封公司介绍邮件，
                    我们<span>公司的优势</span>:20年非标零部件加工经验，设备先进，具有汽车、医疗等行业经验
                    <span class="use" @click="useActive('我是一家做非标零部件的中国工厂，我想用英文给我的外贸客户发一封公司介绍邮件，我们公司的优势:20年非标零部件加工经验，设备先进，具有汽车、医疗等行业经验')">使用场景</span>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="邮件主题" name="second">
                  <div class="ExampleDivtitle">
                    使用示例：
                  </div>
                  <div class="ExampleDiv">
                    · 我是一名机加工工厂的外贸员，想给美国客户写一封开发信，请给我5个邮件主题，能够吸引买家打开邮件，邮件主题精简且有吸引力
                    <span class="use" @click="useActive('我是一名机加工工厂的外贸员，想给美国客户写一封开发信，请给我5个邮件主题，能够吸引买家打开邮件，邮件主题精简且有吸引力')">使用场景</span>
                  </div>
                  <div class="ExampleDiv">
                    · 我是工厂外贸员，想要写一封英文圣诞节祝福信，请给我5个邮件主题，邮件主题精简温馨
                    <span class="use" @click="useActive('我是工厂外贸员，想要写一封英文圣诞节祝福信，请给我5个邮件主题，邮件主题精简温馨')">使用场景</span>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="沟通话术" name="third">
                  <div class="ExampleDivtitle">
                    使用示例：
                  </div>
                  <div class="ExampleDiv">
                    · 与欧美客户沟通需要注意哪些礼节?
                    <span class="use" @click="useActive('与欧美客户沟通需要注意哪些礼节?')">使用场景</span>
                  </div>
                  <div class="ExampleDiv">
                    · 外贸新人，如何与客户打开话匣子?
                    <span class="use" @click="useActive('外贸新人，如何与客户打开话匣子?')">使用场景</span>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="合作流程" name="fourth">
                  <div class="ExampleDivtitle">
                    使用示例：
                  </div>
                  <div class="ExampleDiv">
                    · 了解外贸接单后合作流程细节
                    <span class="use" @click="useActive('了解外贸接单后合作流程细节')">使用场景</span>
                  </div>
                  <div class="ExampleDiv">
                    · 外贸合作后涉及的单据有哪些?
                    <span class="use" @click="useActive('外贸合作后涉及的单据有哪些?')">使用场景</span>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-form>
          </div>
        </div>
        <!-- <div class="statement">
          海贸通AI写信免责声明
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {credits,generate} from "@/utils/api/edmSubject"
import { uuid }  from '@/utils/common';
import { onlineUrl } from '@/utils/config';
require("es6-promise").polyfill();
require('isomorphic-fetch');
import * as dialogDrag from '@/directives/dialogDrag'

export default {
  props:{
    headerAIDrawer:{
      type:Boolean,
      default:true
    }
  },
  data(){
    return{
      onlineUrl:onlineUrl,
      request:'',
      creditsValue:0,
      creditUse:0,
      balance:0,
      list:[],
      creditShow:false,
      timer: null,
      textCount: '',
      tempText:'',
      loading:false,
      activeName:'first',
      contextId:`${uuid()}`,
      amplifyShow:false
    }
  },
  methods:{
    blur(){
      this.request=this.request.trim()
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      var Aidraw=document.querySelector('.el-dialog__body');
      setTimeout(function(){
        // console.log(Aidraw.scrollHeight)
      //   console.log(Aidraw.clientHeight)
        if(Aidraw.scrollHeight > Aidraw.clientHeight) {
          //设置滚动条到最底部
          Aidraw.scrollTop = Aidraw.scrollHeight;
        }
      },50);
    },
    
    handleClose(){
      this.$emit('AIdrawer',false)
    },
    closed(){
      this.$nextTick(()=>{
        this.amplifyShow=false
      })
    },
    amplify(){
      this.amplifyShow=!this.amplifyShow
      
      // console.log(this.amplifyShow)
      if(this.amplifyShow){
        this.$nextTick(()=>{
          console.log(document.querySelector('.AIdraweramplify').style.left='-300px')
          // document.querySelector('.el-dialog').style.cssText += `;left:-400px !important;top:30px !important;`
        })
      }else{
        // document.querySelector('.el-dialog').style.cssText += `;left:0px !important;top:110px !important;`
      }
    },
    // 查询当天余额
   async getCredits(){
      const res= await credits()
      // console.log(res)
      this.creditsValue=Number(res.data.value.split('/')[1])
      this.creditUse=Number(res.data.value.split('/')[1])-Number(res.data.value.split('/')[0])
      this.balance=Number(res.data.value.split('/')[0])
    },
    // 复制文档
    copy(content){
      var tempInput = document.createElement("textarea");
      document.body.appendChild(tempInput);
      tempInput.value = content;
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      this.$message.success('复制成功');
    },
    async createdValue(){
      let request={
        content:this.request.trim(),
        code:0,
        btnShow:false
      }
      this.list.push(request)
      let answer={
        content:'内容生成中，请稍后……',
        code:1,
        btnShow:false
      }
      this.list.push(answer)
      const params={
        prompt:this.request.trim(),
        contextId:this.contextId
      }
      this.creditShow=true
      this.loading=true
      fetch(`${this.onlineUrl}/seamark/supplier/ai-template/generate`,{ method:'post',headers:{
        'Content-Type': 'application/json'},
        credentials: 'include',
        body: JSON.stringify(params)}).then(response=>{
        // 创建文本解码器并获取可读流
        const decoder = new TextDecoder();
        const reader = response.body.getReader();
        this.list[this.list.length-1].content=''
            // 递归函数来读取并处理流数据
        const read = () => {
          reader.read().then(({ done, value }) => {
            // console.log('读取', done, value)
            if (done) {
              this.loading=false
              this.getCredits()
              this.request=''
              this.list[this.list.length-1].btnShow=true
              return;
            }

            // 解码并分割事件
            const text = decoder.decode(value);
            const events = text.split('\n');
            this.list[this.list.length-1].content+=text
            
            // console.log('events', events)
            // console.log(text)
            
            // 处理每一个事件
            // events.forEach(event => {
            //   console.log(event)
            //   // const data = JSON.parse(event.substring(6).replace(/\n/g, ''));
            //   this.list[this.list.length-1].content+=event
            //   // console.log(data);
            // });
            // 继续读取下一段流数据
            read();
          })
        };
        // 开始读取流数据
        read();
       
      }).catch(error => {
        console.error(error);
        this.loading=false
        this.request=''
      });

      return
      // const delaytimeList = [46, 51, 76, 66, 30, 80];
      // const res=await generate(params)
      // this.textCount=res
      // console.log(res)
      // this.getCredits()
      // this.delayDo(
      //   this.textCount,
      //   (item, i) => {
      //     this.getChatContent(item, i);
      //   },
      //   delaytimeList
      // );
    },
    useActive(request){
      if(this.balance>0&&!this.loading){
        this.request=request
        // this.createdValue()
      }
    },
    // 延时函数
    // sleep(delaytime = 100) {
    //   return new Promise(resolve => setTimeout(resolve, delaytime));
    // },
     // 同步遍历，自定义延时时间
    // async delayDo(
    //   iterList,
    //   callback = data => console.log(`数据：${data}`),
    //   delaytimeList
    // ) {
    //   let len = iterList.length;
    //   for (let i = 0; i < len; i++) {
    //     callback(iterList[i], i);
    //     await this.sleep(delaytimeList[i]);
    //   }
    // },
      // 逐字显示内容
    // getChatContent(text, index) {
    //   this.tempText+=text
    //   this.list[this.list.length-1].content=this.tempText
    //   if(this.tempText.length==this.textCount.length){
    //     this.list[this.list.length-1].btnShow=true
    //   }
    // },
  },
  updated(){
      if(this.list.length>0){
        var div=document.querySelector('.templateCard');
        // div.scrollTop = div.scrollHeight;
        //判断元素是否出现了滚动条
        setTimeout(function(){
          if(div.scrollHeight > div.clientHeight) {
            //设置滚动条到最底部
            div.scrollTop = div.scrollHeight;
          }
        },500);
      }
  },
  mounted(){
     this.getCredits()  

  }
} 
</script>

<style lang="scss" scoped>
.gifAIOther{
 
  .otherDrawer{
    position: fixed;
    bottom: -42px;
    right: 24px;
    -webkit-transform: perspective(1px) translateZ(0);
    transform: perspective(1px) translateZ(0);
    z-index: 10;
    img{
    width: 110px;
    height: 160px;
    cursor: pointer;
    }
  }
  .otherDrawer:hover{
    position: fixed;
    bottom: -16px;
    right: 24px;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    z-index: 10;
  }

}

.gifAI{
  position: fixed;
  bottom: 139px;
  right: 100px;
  img{
    width: 128.48px;
    height: 174px;
    cursor: pointer;
  }
  .shadow{
    position: fixed;
    bottom: 136px;
    right: 120px;
    width: 88px;
    height: 40px;
    z-index: -1;
  }
  .dialogue{
    background:url('~@/assets/image/common/dialogue.png') no-repeat center 100%;
    background-size: 100% 100%;
    position: fixed;
    bottom: 265px;
    right: 103px;
    .dialogueText{
      padding: 30px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 20px;
      cursor: pointer;
      .dialogueTextP{
        margin-top: 8px;
      }
      .footBotoom{
        padding-bottom: 30px;
      }
    }
  }
}
.AIBgTexttrue{
  // background:url('~@/assets/image/common/AIbg.png') no-repeat center 100%;
  background-size: 100% 100%;
  height: 360px;
  margin-top: 12px;
  .title{
    margin-bottom: 18px;
    // padding-top: 114px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 18px;
    text-align: center;
  }
  .titleTop{
    margin-bottom: 24px;
    padding-top: 114px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 18px;
    text-align: center;
  }
  .introduce{
    // text-align: center;
    margin-top: 48px;
    .content{
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #4F5D78;
      text-align: center;
      .ImgDiv{
        // width: 44px;
        // height: 44px;
        img{
          width: 44px;
          height: 44px;
        }
        margin-bottom: 14px
      }
      .contentText{
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #16181A;
        margin-bottom: 10px;
      }
      .processConter{
        text-align: left;
        margin-left: 40px;
        line-height: 26px;
      }
      .EmailConter{
        text-align: left;
        margin-left: 40px;
        line-height: 24px;
        .EmailDiv{
          width: 175px;
          line-height: 16px;
        }
      }
      .interactConter{
        text-align: left;
        margin-left: 40px;
        line-height: 26px;
      }
    }
  }
}
.AIBgTextfalse{
  background:url('~@/assets/image/common/AIbg.png') no-repeat center 100%;
  background-size: 100% 100%;
  height: 300px;
  .title{
    margin-bottom: 24px;
    // padding-top: 114px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 18px;
    text-align: center;
  }
  .titleTop{
    margin-bottom: 24px;
    padding-top: 114px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 18px;
    text-align: center;
  }
  .introduce{
    // text-align: center;
    margin-top: 48px;
    .content{
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #4F5D78;
      text-align: center;
      .ImgDiv{
        // width: 44px;
        // height: 44px;
        img{
          width: 44px;
          height: 44px;
        }
        margin-bottom: 14px
      }
      .contentText{
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #16181A;
        margin-bottom: 10px;
      }
      .processConter{
        text-align: left;
        margin-left: 40px;
        line-height: 26px;
      }
      .EmailConter{
        text-align: left;
        margin-left: 40px;
        line-height: 24px;
        .EmailDiv{
          width: 175px;
          line-height: 16px;
        }
      }
      .interactConter{
        text-align: left;
        margin-left: 40px;
        line-height: 26px;
      }
    }
  }
}
.problemTitle{
  margin-top: 10px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #394BAC;
  padding-left: 32px;
  span{
    // cursor: pointer;
  }
  .problemTitleSpan{
    margin: 0 20px;
  }
  .todayuse{
    float: right;
    // padding-right: 32px;
    color: #98a3b7ff;
    font-size: 12px;
  }
}
.requestInput{
  padding-left: 32px;
  padding-top: 56px;
  padding-right: 32px;
  ::v-deep .textareaInput {
    .el-textarea__inner{
      // padding: 14px 115px 14px 15px !important;
      line-height: 21px;
      padding: 15px 110px 14px 8px !important; // 只要改变这里的 padding 就可以影响到 textarea 的高度
      // padding-right: 115px !important;
      border-color: #394BAC;
      scrollbar-width: thin;
    }
    ::placeholder{
      font-size: 12px;
      line-height: 20px;
    }
    
  }

      /**修改全局的滚动条*/
  /**滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 6px;
  }
  // 滚动条的滑块
  ::-webkit-scrollbar-thumb {
    background-color: rgba(144,147,153,.3);
    border-radius: 3px;
  }
  .appendBtnDivfalse{
    position: relative;
    /* right: 1px; */
    text-align: right;
    margin-left: auto;
    right: 88px;
    top: -45px;
    width: 104px;
    .appendBtn{
      // width: 80px;
      height: 36px;
      background-image: linear-gradient(90deg, #394BAC 0%, #3025BD 100%);
      border-radius: 4px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 12px;
      color: #FFFFFF;
      position: absolute;
    }
  }
  .appendBtnDivtrue{
    position: relative;
    /* right: 1px; */
    text-align: right;
    margin-left: auto;
    right: 104px;
    top: -45px;
    width: 104px;
    .appendBtn{
      // width: 80px;
      height: 36px;
      background-image: linear-gradient(90deg, #394BAC 0%, #3025BD 100%);
      border-radius: 4px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 12px;
      color: #FFFFFF;
      position: absolute;
    }
  }
  
}
::v-deep .Example{
  margin: 0 32px;
  .el-tabs__item.is-active{
    color: #394BAC;
  }
  .el-tabs__item{
    font-size: 12px;
  }
  .el-tabs__active-bar{
    background-color: #394BAC;
  }
  .el-tabs__item:hover{
    color: #394BAC;
  }
  .el-form-item__label{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #3D485D;
  }
  .el-form-item__content{
    color: #3d485dff;
    font-size: 12px;
    font-family: SourceHanSansCN-Regular;
  }
  .ExampleDivtitle{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #4F5D78;
  }
  .ExampleDiv{
    color: #3d485dff;
    font-size: 12px;
    font-family: SourceHanSansCN;
    margin-top: 12px;
    line-height: 24px;
    span{
      font-family: SourceHanSansCN-Medium;
      color: #16181aff;
    }
    .use{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #066EB7;
    cursor: pointer;
    margin-left: 8px;
  }
  }
}
.ExampleconteDiv{
  margin-top: 34px;
  padding-bottom: 32px;
}
.ExampleconteDivTop{
  margin-top: 152px;
}
.statement{
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #CFD5DF;
  text-align: center;
}
.templateCard{
margin: 0 32px;
background: #FFFFFF;
// border: 1px solid #CFD5DF;
height: 439px;
overflow: auto;
.myQuestion{
  display: flex;
  margin: 16px;
  align-items: center;
  .myQuestionText{
    font-size: 14px;
    white-space: pre-wrap;
    color: #16181A;
  }

  .myQuestionImg{
    margin-right: 16px;
    align-self: flex-start;
    .divImg{
      width: 40px;
      height: 40px;
      background: #1937C6;
      border-radius: 4px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      line-height: 40px;
    }
  }
}
.answerDiv{
  background: rgba(49,140,237,.1);
  .answer{
    display: flex;
    padding: 16px;
    align-items: center;
    .answerImg{
      align-self: flex-start;
    }
    .divImg{
      width: 40px;
      height: 40px;
      background: #FFFFFF;
      border-radius: 5px;
      margin-right: 16px;
      img{
        width: 100%;
      }
    }
    .answerText{
      font-size: 14px;
      color: #16181A;
      white-space: pre-wrap;
      .copy{
        background: #318CED;
        border-radius: 4px;
        border: none;
        margin-top: 8px;
      }
    }
  }
}

}
.aiDrawerConterDiv{
  // background-image: linear-gradient(180deg, #F0F4FF 0%, #FFFFFF 100%);
  // box-shadow: -2px 0 6px 0 #003b7126;
  // border-radius: 4px 0 0 4px;
  // border-radius: 4px 0 0 4px;

}
.titleDiv{
  text-align: center;
  .fontclose{
    color: #98A3B7;
    font-size: 16px;
    text-align: right;
    // float: right;
    // margin-right: 32px;
    margin-top: 20px;
    // border-radius: 50%;
    // background: #E9F1FF;
    padding: 2px;
    margin-left: 50px;
    position: absolute;
    right: 30px;
    top: 1px;
    cursor: pointer;
  }
  .fontamplify{
    color: #98A3B7;
    font-size: 16px;
    text-align: right;
    // float: right;
    // margin-right: 32px;
    margin-top: 20px;
    // border-radius: 50%;
    // background: #E9F1FF;
    padding: 2px;
    margin-left: 50px;
    position: absolute;
    right: 80px;
    top: 1px;
    cursor: pointer;
  }
}


</style>
<style lang="scss">
.AIdrawerWrapper{
  height: calc(100vh + 60px);
  // width: 500px;
  // margin-left: auto;
  // background-image: linear-gradient(180deg, #F0F4FF 0%, #FFFFFF 100%);
  box-shadow: -2px 0 6px 0 #003b7126;
  border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
  pointer-events: none;
        /**修改全局的滚动条*/
  /**滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 6px;
  }
  // 滚动条的滑块
  ::-webkit-scrollbar-thumb {
    background-color: rgba(144,147,153,.3);
    border-radius: 3px;
  }
}
.AIdrawer{
  height: calc(100vh - 96px) !important;
  width: 500px !important;
  // height: 670px !important;
  pointer-events: all;
  margin: 8vh 0 50px auto !important;
  // overflow: auto;
  // width: 500px !important;
  border-radius: 4px;
  background-image: linear-gradient(180deg, #F0F4FF 0%, #FFFFFF 100%);
  box-shadow: -2px 0 6px 0 #003b7126; 
  border-radius: 4px 0 0 4px;
  border-radius: 4px 0 0 4px;
  // user-select: auto;
  //   touch-action: none;
  //   width: 1085.6px;
  //   height: 749.6px;
  //   display: inline-block;
  //   top: 0px;
  //   left: 0px;
  //   cursor: auto;
  //   pointer-events: all;
  //   z-index: 101;
  //   transform: translate(223.7px, 98.7px);
  //   max-width: 1085.6px;
  //   min-width: 368px;
  //   min-height: 352px;
  //   box-sizing: border-box;
  //   max-height: 1024px;
  .title{
    font-family: SourceHanSansCN-Bold;
    font-weight: 700;
    font-size: 20px;
    color: #16181A;
    text-align: center;
    padding-top: 18px;
  }
  .el-dialog__body{
    // overflow-y: scroll !important;
    overflow: auto;
    scrollbar-width: thin;
    // height: 590px;
    height: calc(100vh - 156px) !important;
    padding: 0px;
  }
  .el-dialog__header{
    // padding:0px;
    background: #D0DFF6;
  }
}
.closeBtnAi{
  position: fixed;
  right: 483px;
  top: 36px; 
  box-shadow: 2px 0 4px 0 #E9F1FF;
  border-radius: 2px;
  background: #E9F1FF;
  border-color: #E9F1FF;
  color: #97A5FD;
  .iconfont{
    margin-left: 4px;
    font-size: 12px;
  }
}
.closeBtnAi:hover{
  background: #E9F1FF !important;
  border-color: #E9F1FF !important;
  color: #97A5FD !important;
}
.AIdraweramplify{
  width: 901px !important;
  // margin: 0 auto 50px !important;
  // user-select: auto;
  //   touch-action: none;
  //   width: 1085.6px;
  //   height: 749.6px;
  //   display: inline-block;
  //   top: 0px;
  //   left: 0px;
  //   cursor: auto;
  //   pointer-events: all;
  //   z-index: 101;
  //   transform: translate(135.7px, 93.7px);
  //   max-width: 1085.6px;
  //   min-width: 368px;
  //   min-height: 352px;
  //   box-sizing: border-box;
  //   max-height: 1024px;
}
</style>